Apt.fn.make('properties', {
	/**
	 * Initialize module
	 */
	init() {
		const scope = this;
		const priv = scope.$private;
		const section = priv.section;

		if (section && section !== 'properties') {
			Apt[section].unload();
		}

		priv.section = 'properties';
		priv.customMap = null;

		const path = $.routes.uri().path;
		const navigate = path !== priv.path;

		priv.path = path;

		if (priv.index) {
			if (navigate) {
				priv.refresh();
			}

			return;
		}

		priv.filters = Apt.fn.filters()
			.init();

		priv.initApp();

		priv.initMobile(() => {
			priv.loadMap();
		});

		priv.meta = Apt.fn.meta()
			.init();

		scope.prefetch();
	},

	/**
	 * Evaluate preload logic
	 */
	preload() {
		const section = this.$private.section || 'properties';

		if (! Apt[section].$private.index || section !== 'properties') {
			return;
		}

		if (Apt.panel.opened()) {
			Apt.panel.hide();
		}

		const pending = $.history.pending();

		if (! pending || ! pending.action || ! pending.run) {
			return;
		}

		pending.action = false;
	},

	/**
	 * Prefetch property assets
	 */
	prefetch() {
		const path = '/assets/modules/property@' + $.get('versions.property') + '/';

		LS.util.prefetch([
			path + 'style.min.css',
			path + 'script.min.js'
		]);
	},

	/**
	 * Unload module
	 *
	 * @param {Boolean} [force=false]
	 */
	unload(force) {
		const scope = this;
		const priv = scope.$private;
		const section = priv.section;

		if (! section) {
			return;
		}

		if (section !== 'properties') {
			Apt[section].unload();

			return;
		}

		if (force !== true) {
			if (Apt.panel.opened()) {
				return;
			}

			const history = $.history.get(true);

			if (history && (LS.filters.isProperty(history.segments[0]))) {
				return;
			}
		}

		priv.section = null;

		LS.util.reset('properties', priv, [
			'fallback',
			'filters',
			'index',
			'meta',
			'sync'
		], true);

		if (priv.map) {
			priv.map.minimize();

			if (! Apt.panel.opened()) {
				LS.util.destroy(priv, 'map');
			}
		}

		scope.showList();
	}
}, {
	/**
	 * Get ad targeting
	 *
	 * @returns {Object}
	 */
	getTargeting() {
		const filters = LS.filters.get();
		const targeting = {
			section: 'properties'
		};

		if (filters.format) {
			targeting.format = filters.format;
		}

		let tag = [];
		let value;

		[
			'tag',
			'type'
		].forEach(key => {
			value = $.toArray(filters[key]);

			if (value) {
				tag = [
					...tag,
					...value
				];
			}
		});

		if (tag.length) {
			targeting.tag = tag;
		}

		[
			'price',
			'size'
		].forEach(key => {
			value = filters[key];

			if (value) {
				value = value.max || value.min;

				if (value) {
					value = LS.util.closest(value, key === 'price' ?
						[0, 50000, 100000, 250000, 500000, 1000000, 2500000, 5000000, 10000000] :
						[0, 5, 10, 20, 50, 100, 250, 500, 1000]
					);

					if (value) {
						targeting[key] = value;
					}
				}
			}
		});

		const loc = LS.location.context();

		if (loc) {
			Object.assign(targeting, loc);
		}

		return targeting;
	}
});